import Loader from '@App/components/ui/Loader';

export default function LoadingBreadCrumbItem() {
    return <li className="breadcrumb__item"><Loader /></li>;
}
